import { NgModule, Pipe, PipeTransform } from '@angular/core'
import { Money } from '@service/money.static'
import { SharedModule } from '../shared.module'

@Pipe({
  name: 'moneyInsertThousandSigns',
})
export class MoneyInsertThousandSigns implements PipeTransform {
  transform(value: string): string {
    return Money.insertThousandSigns(value)
  }
}

@NgModule({
  declarations: [
    MoneyInsertThousandSigns
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    SharedModule,

    MoneyInsertThousandSigns
  ]
})
export class MoneyInsertThousandSignsModule { }